"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dentalClinicApi = require("@/api/dentalClinicApi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ClinicBinding',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    productId: {
      type: Number,
      default: null
    },
    selectedClinicIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listLoading: false,
      searchForm: {
        page: 1,
        limit: 10,
        keyword: ''
      },
      clinicList: [],
      total: 0,
      selectedClinics: []
    };
  },
  watch: {
    visible: function visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getList();
      }
    },
    selectedClinicIds: {
      handler: function handler(val) {
        this.selectedClinics = val;
      },
      immediate: true
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        page: this.searchForm.page,
        limit: this.searchForm.limit,
        keyword: this.searchForm.keyword
      };
      (0, _dentalClinicApi.getClinicList)(params).then(function (res) {
        _this.clinicList = res.list || [];
        _this.total = res.total || 0;

        // 预选已绑定的诊所
        _this.$nextTick(function () {
          if (_this.selectedClinicIds && _this.selectedClinicIds.length > 0) {
            _this.clinicList.forEach(function (row) {
              if (_this.selectedClinicIds.includes(row.id)) {
                _this.$refs.table.toggleRowSelection(row, true);
              }
            });
          }
        });
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    resetSearch: function resetSearch() {
      this.searchForm.keyword = '';
      this.searchForm.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedClinics = val.map(function (item) {
        return item.id;
      });
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    confirmBinding: function confirmBinding() {
      this.$emit('confirm', this.selectedClinics);
      this.handleClose();
    }
  }
};